import React from 'react';
import cx from 'classnames';
import styles from './MilestoneProgress.m.sass';
var MilestoneProgress = function MilestoneProgress(_ref) {
  var completedCount = _ref.completedCount,
    totalCount = _ref.totalCount,
    spin = _ref.spin,
    locked = _ref.locked,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size;
  var scale = Math.min(completedCount / Math.max(totalCount, 1), 1);
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.root, styles[size])
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(styles.circle, styles[size])
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.fill,
    style: {
      transform: "scaleY(".concat(scale, ")")
    }
  }), /*#__PURE__*/React.createElement("img", {
    src: require('./graphic-radial.svg'),
    className: cx(styles.radial, spin && styles.spin)
  }), /*#__PURE__*/React.createElement("img", {
    src: require('./trophy.svg'),
    className: cx(styles.icon)
  })), locked && /*#__PURE__*/React.createElement("img", {
    src: require('./icon-lock.svg'),
    alt: "Lock icon",
    className: cx(styles.lock, styles[size])
  }));
};
export default MilestoneProgress;
//# sourceMappingURL=index.js.map
